(() => {
  if (customElements.get('product-form-ajax')) return;

  class ProductFormAjax extends HTMLElement {
    constructor() {
      super();
      this.onSubmit = this.onSubmit.bind(this);
      this.markReady = this.markReady.bind(this);
    }

    connectedCallback() {
      this.addEventListener('submit', this.onSubmit);
      this.setReadyWhenPossible();
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.onSubmit);
      document.removeEventListener('DOMContentLoaded', this.markReady);
    }

    get themeReady() {
      return !!(window.jQuery && window.theme && theme.routes && theme.settings && theme.handleProductFormSubmit);
    }

    get form() {
      return this.querySelector('form.product-purchase-form');
    }

    setReadyWhenPossible() {
      if (this.markReady()) return;
      document.addEventListener('DOMContentLoaded', this.markReady);
    }

    markReady() {
      if (!this.themeReady) return false;

      var form = this.form;
      if (!form) return false;

      theme.productFormReady(form);
      return true;
    }

    onSubmit(evt) {
      var form = evt.target;
      if (!form.matches || !form.matches('form.product-purchase-form')) return;

      if (evt.defaultPrevented) return;
      if (!this.themeReady) return;

      if (theme.handleProductFormSubmit(form)) {
        evt.preventDefault();
      }
    }
  }

  customElements.define('product-form-ajax', ProductFormAjax);
})();
